(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (function () {
    function initBreedGuide(scope) {
      var templates = scope.querySelectorAll('.js-tt-breed-guide-template');

      templates.forEach(function (template) {
        var sectionHost = template.closest('.shopify-section');
        var oldGuide = sectionHost ? sectionHost.querySelector('.tt-sg__breeds') : null;

        if (!sectionHost || !oldGuide || !template.content) {
          return;
        }

        oldGuide.replaceWith(template.content.cloneNode(true));
        template.remove();

        var guide = sectionHost.querySelector('.tt-breed-guide');
        var track = guide ? guide.querySelector('.js-tt-breed-track') : null;
        var cards = guide ? Array.from(guide.querySelectorAll('.js-tt-breed-card')) : [];
        var dots = guide ? Array.from(guide.querySelectorAll('.js-tt-breed-dot')) : [];
        var previous = guide ? guide.querySelector('.js-tt-breed-prev') : null;
        var next = guide ? guide.querySelector('.js-tt-breed-next') : null;
        var activeIndex = 0;
        var ticking = false;

        if (!track || cards.length === 0 || dots.length !== cards.length || !previous || !next) {
          return;
        }

        function cardOffset(card) {
          return card.offsetLeft - track.offsetLeft;
        }

        function setActive(index) {
          activeIndex = Math.max(0, Math.min(index, cards.length - 1));

          dots.forEach(function (dot, dotIndex) {
            if (dotIndex === activeIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          previous.disabled = activeIndex === 0;
          next.disabled = activeIndex === cards.length - 1;
        }

        function goTo(index) {
          var targetIndex = Math.max(0, Math.min(index, cards.length - 1));
          track.scrollTo({ left: cardOffset(cards[targetIndex]), behavior: 'smooth' });
          setActive(targetIndex);
        }

        previous.addEventListener('click', function () {
          goTo(activeIndex - 1);
        });

        next.addEventListener('click', function () {
          goTo(activeIndex + 1);
        });

        dots.forEach(function (dot, dotIndex) {
          dot.addEventListener('click', function () {
            goTo(dotIndex);
          });
        });

        track.addEventListener('scroll', function () {
          if (ticking) {
            return;
          }

          ticking = true;
          window.requestAnimationFrame(function () {
            var nearestIndex = 0;
            var nearestDistance = Infinity;

            cards.forEach(function (card, cardIndex) {
              var distance = Math.abs(cardOffset(card) - track.scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = cardIndex;
              }
            });

            setActive(nearestIndex);
            ticking = false;
          });
        }, { passive: true });

        setActive(0);
      });
    }

    function initialize() {
      initBreedGuide(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initBreedGuide(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
